"use strict";

export function initInScope ($scope) {
    $scope.find('.js-dropdown-menu-keep-open').on('click', function (evt) {
        evt.stopImmediatePropagation();
    });
}